
import React, { Fragment } from "react";
import _ from "lodash";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton } from "components/Global/Buttons";
import styled from "styled-components";

const Container = styled.div`
  height:calc(100vh - 360px);
`;

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
  }
`;
/*
 * browser detection taken from https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 * Internet Explorer 6-11
 */
const isIE = /* @cc_on!@*/false || Boolean(document.documentMode);
// Edge 20+
const isEdge = !isIE && Boolean(window.StyleMedia);

const renderIframe = iframeValue => {
  const iframe = `<iframe id="ifm" name="ifm" width="100%" height="100%" frameborder="0" src="${iframeValue}" scrolling="auto"></iframe>`;
  if (isEdge) {
    return (<h2>We're sorry. LoanBoss Reporting is not supported on your browser. Please use Chrome or Firefox instead.</h2>);
  }

  return (<Container dangerouslySetInnerHTML={{ __html: iframe ? iframe : "" }} />);
};

const ChartOnlyDialog = ({ title, iframe, modalOpen, handleClose, maxWidth }) => {
  const url = !iframe ? "http://www.google.com" : iframe;

  return (
    <Dialog fullWidth maxWidth={maxWidth} open={modalOpen} onClose={handleClose} id={"chartOnlyDialog"}>
      <DialogTitle>{title}</DialogTitle>
      <StyledDialogIconButton onClick={handleClose}>
        <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
      </StyledDialogIconButton>
      <StyledDialogContent>
        {renderIframe(url)}
      </StyledDialogContent>
      <DialogActions>
        <PrimaryButton id="dialogYes" onClick={handleClose}>CLOSE</PrimaryButton>
      </DialogActions>
    </Dialog>);
};

export default ChartOnlyDialog;
